import { useState, useEffect, useRef } from "react";

// ── PERSISTENT STORAGE — localStorage for hosted deployment ──
const store = {
  get: async (key) => {
    try {
      const val = localStorage.getItem(key);
      return val ? JSON.parse(val) : null;
    } catch { return null; }
  },
  set: async (key, val) => {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch {}
  },
};

// ── SEED DATA ────────────────────────────────────────
const SEED = {
  bookings: [
    { id:"BK001", client:"Priya Sharma Weddings", phone:"9876543210", eventType:"Premium Wedding", date:"2025-07-10", venue:"Taj Falaknuma", city:"Hyderabad", guests:150, therapists:6, hours:8, package:"Premium", amount:45000, advance:15000, status:"Confirmed", payStatus:"Advance Paid", lead:"Anitha Reddy", notes:"Floral theme. No lavender." },
    { id:"BK002", client:"TCS Hyderabad", phone:"8765432109", eventType:"Corporate Event", date:"2025-07-15", venue:"HITEC City Campus", city:"Hyderabad", guests:80, therapists:4, hours:5, package:"Essential", amount:18000, advance:0, status:"Confirmed", payStatus:"Unpaid", lead:"Kavitha Rani", notes:"HR Wellness Day" },
    { id:"BK003", client:"Radisson Blu", phone:"7654321098", eventType:"Hotel Program", date:"2025-07-20", venue:"Radisson Banjara Hills", city:"Hyderabad", guests:40, therapists:2, hours:4, package:"Premium", amount:25000, advance:10000, status:"Confirmed", payStatus:"Advance Paid", lead:"Anitha Reddy", notes:"Monthly retainer" },
    { id:"BK004", client:"Amazon India", phone:"9988776655", eventType:"Corporate Event", date:"2025-07-25", venue:"Amazon HQ Hyderabad", city:"Hyderabad", guests:200, therapists:8, hours:6, package:"Signature", amount:85000, advance:25000, status:"Enquiry", payStatus:"Unpaid", lead:"Swetha Nair", notes:"Annual day event" },
  ],
  payments: [
    { id:"PAY001", bookingId:"BK001", client:"Priya Sharma Weddings", date:"2025-06-20", amount:15000, status:"Paid", mode:"UPI - GPay", txnId:"TXN8234729834", invoice:"INV/25-26/001", receipt:"Yes - WhatsApp" },
    { id:"PAY002", bookingId:"BK002", client:"TCS Hyderabad", date:"", amount:18000, status:"Pending", mode:"", txnId:"", invoice:"INV/25-26/002", receipt:"No" },
    { id:"PAY003", bookingId:"BK003", client:"Radisson Blu", date:"2025-06-25", amount:10000, status:"Paid", mode:"NEFT", txnId:"NEFT20250625001", invoice:"INV/25-26/003", receipt:"Yes - Email" },
    { id:"PAY004", bookingId:"BK004", client:"Amazon India", date:"2025-06-28", amount:25000, status:"Paid", mode:"Bank Transfer", txnId:"RTGS20250628002", invoice:"INV/25-26/004", receipt:"Yes - WhatsApp" },
  ],
  staff: [
    { id:"S001", name:"Anitha Reddy", phone:"9876501234", role:"Team Lead", specialization:"Multi-skilled", certifications:"Reflexology, Aromatherapy, Hot Stone", joined:"2023-06-01", dailyRate:1800, monthlySalary:0, status:"Active", city:"Hyderabad", emergency:"9876501235", notes:"Senior lead for VIP events" },
    { id:"S002", name:"Kavitha Rani", phone:"9876502345", role:"Therapist", specialization:"Foot Reflexology", certifications:"Reflexology Certified", joined:"2024-01-15", dailyRate:1400, monthlySalary:0, status:"Active", city:"Hyderabad", emergency:"9876502346", notes:"Best for weddings" },
    { id:"S003", name:"Swetha Nair", phone:"9876503456", role:"Therapist", specialization:"Aromatherapy", certifications:"Aromatherapy, Swedish", joined:"2024-03-10", dailyRate:1400, monthlySalary:0, status:"Active", city:"Hyderabad", emergency:"9876503457", notes:"Weekends preferred" },
    { id:"S004", name:"Ramesh Kumar", phone:"9876504567", role:"Sales Executive", specialization:"B2B Sales", certifications:"", joined:"2024-06-01", dailyRate:0, monthlySalary:18000, status:"Active", city:"Hyderabad", emergency:"9876504568", notes:"5% commission on bookings" },
  ],
  clients: [
    { id:"CL001", company:"Priya Sharma Weddings", contact:"Priya Sharma", phone:"9876543210", email:"priya@email.com", type:"Wedding Client", city:"Hyderabad", status:"Active", notes:"Premium client. Referred by Meena." },
    { id:"CL002", company:"TCS Hyderabad", contact:"Anand Kumar (HR)", phone:"8765432109", email:"hr@tcs.com", type:"Corporate/IT", city:"Hyderabad", status:"Active", notes:"Budget ₹20K/event" },
    { id:"CL003", company:"Radisson Blu", contact:"Events Manager", phone:"7654321098", email:"events@radisson.com", type:"5-Star Hotel", city:"Hyderabad", status:"Retainer", notes:"Monthly auto-renewal" },
    { id:"CL004", company:"Amazon India", contact:"Sneha (HR)", phone:"9988776655", email:"hr.hyd@amazon.com", type:"Corporate/IT", city:"Hyderabad", status:"Active", notes:"Large events, high budget" },
  ],
  assignments: [
    { id:"AS001", bookingId:"BK001", staff:"Anitha Reddy", date:"2025-07-10", eventType:"Premium Wedding", client:"Priya Sharma Weddings", venue:"Taj Falaknuma", shiftStart:"09:00", shiftEnd:"18:00", role:"Lead Therapist", attendance:"Confirmed", dayRate:1800, notes:"Lead bridal lounge" },
    { id:"AS002", bookingId:"BK001", staff:"Kavitha Rani", date:"2025-07-10", eventType:"Premium Wedding", client:"Priya Sharma Weddings", venue:"Taj Falaknuma", shiftStart:"09:00", shiftEnd:"18:00", role:"Therapist", attendance:"Confirmed", dayRate:1400, notes:"" },
    { id:"AS003", bookingId:"BK002", staff:"Swetha Nair", date:"2025-07-15", eventType:"Corporate Event", client:"TCS Hyderabad", venue:"HITEC City", shiftStart:"09:00", shiftEnd:"14:00", role:"Therapist", attendance:"Assigned", dayRate:700, notes:"Half day" },
  ],
  inventory: [
    { id:"INV001", item:"Foot Spa Tubs", category:"Equipment", qty:12, unit:"Pcs", minQty:8, cost:2500, supplier:"Wellness Supplies Co", lastRestocked:"2025-06-01", notes:"Check before each event" },
    { id:"INV002", item:"Essential Oils (Lavender)", category:"Products", qty:24, unit:"Bottles", minQty:10, cost:450, supplier:"Aroma India", lastRestocked:"2025-06-10", notes:"Order from Aroma India" },
    { id:"INV003", item:"Himalayan Salt", category:"Products", qty:15, unit:"Kg", minQty:5, cost:320, supplier:"Natural Store", lastRestocked:"2025-06-05", notes:"1kg per 8 guests" },
    { id:"INV004", item:"Disposable Liners", category:"Consumables", qty:500, unit:"Pcs", minQty:200, cost:8, supplier:"Hygienic Supplies", lastRestocked:"2025-06-15", notes:"1 per guest" },
    { id:"INV005", item:"Branded Draping Sets", category:"Equipment", qty:6, unit:"Sets", minQty:4, cost:3500, supplier:"Event Decor Ltd", lastRestocked:"2025-05-20", notes:"Dry clean after each use" },
    { id:"INV006", item:"Massage Chairs", category:"Equipment", qty:8, unit:"Pcs", minQty:6, cost:8500, supplier:"Comfort Chairs India", lastRestocked:"2025-04-01", notes:"Check wheels monthly" },
    { id:"INV007", item:"Towels (Premium)", category:"Linen", qty:60, unit:"Pcs", minQty:30, cost:280, supplier:"Textile Mart", lastRestocked:"2025-06-08", notes:"Wash after every event" },
    { id:"INV008", item:"Peppermint Oil", category:"Products", qty:18, unit:"Bottles", minQty:8, cost:380, supplier:"Aroma India", lastRestocked:"2025-06-10", notes:"Popular for corporate" },
  ],
  expenses: [
    { id:"EXP001", date:"2025-06-01", category:"Staff", description:"June salaries & therapist pay", amount:62000, paidTo:"Staff", mode:"Bank Transfer", notes:"" },
    { id:"EXP002", date:"2025-06-05", category:"Products", description:"Essential oils restock", amount:8600, paidTo:"Aroma India", mode:"UPI", notes:"" },
    { id:"EXP003", date:"2025-06-10", category:"Marketing", description:"Meta ads - June", amount:10000, paidTo:"Meta", mode:"Credit Card", notes:"Instagram + Facebook" },
    { id:"EXP004", date:"2025-06-15", category:"Transport", description:"Event logistics - 3 events", amount:4500, paidTo:"Driver", mode:"Cash", notes:"" },
    { id:"EXP005", date:"2025-06-20", category:"Admin", description:"Mobile bills + internet", amount:2800, paidTo:"Airtel", mode:"UPI", notes:"" },
  ],
};

// ── COLOR & STYLE TOKENS ─────────────────────────────
const C = {
  navy:"#0E0B2E", navy2:"#15113D", dark:"#07051A",
  gold:"#C9A030", gold2:"#E8BC50", gold3:"#FFF0B0",
  white:"#FFFFFF", smoke:"#C8BFA0", gray:"#F5F5F5",
  green:"#1A4A2E", green2:"#2D7A4A", lightG:"#E8F5E9",
  red:"#7A1A1A", lightR:"#FFEBEE",
  amber:"#7A5500", lightA:"#FFF8E1",
  blue:"#0D3D6E", lightB:"#E3F2FD",
  purple:"#231960",
};

const STATUS_COLORS = {
  "Confirmed":"#E3F2FD", "Completed":"#E8F5E9", "Cancelled":"#FFEBEE",
  "Enquiry":"#FFF8E1", "In Progress":"#F3E5F5",
  "Paid":"#E8F5E9", "Pending":"#FFF8E1", "Overdue":"#FFEBEE", "Partial":"#E3F2FD",
  "Active":"#E8F5E9", "Inactive":"#FFEBEE", "On Leave":"#FFF8E1",
  "Retainer":"#E8F5E9", "Advance Paid":"#E3F2FD", "Unpaid":"#FFF8E1", "Fully Paid":"#E8F5E9",
};
const STATUS_TEXT = {
  "Confirmed":"#1565C0","Completed":"#2E7D32","Cancelled":"#C62828","Enquiry":"#E65100","In Progress":"#6A1B9A",
  "Paid":"#2E7D32","Pending":"#E65100","Overdue":"#C62828","Partial":"#1565C0",
  "Active":"#2E7D32","Inactive":"#C62828","On Leave":"#E65100",
  "Retainer":"#2E7D32","Advance Paid":"#1565C0","Unpaid":"#E65100","Fully Paid":"#2E7D32",
};

// ── REUSABLE COMPONENTS ──────────────────────────────

function Badge({ status }) {
  return (
    <span style={{
      background: STATUS_COLORS[status] || "#F5F5F5",
      color: STATUS_TEXT[status] || "#333",
      padding:"2px 10px", borderRadius:20, fontSize:11, fontWeight:700,
      whiteSpace:"nowrap"
    }}>{status}</span>
  );
}

function Card({ children, style={} }) {
  return (
    <div style={{
      background:"#fff", borderRadius:12, padding:"20px",
      boxShadow:"0 2px 12px rgba(14,11,46,0.07)",
      border:"1px solid #EEE", ...style
    }}>{children}</div>
  );
}

function KPICard({ label, value, sub, color="#0E0B2E", bg="#F5F5F5", icon }) {
  return (
    <div style={{
      background:`linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
      borderRadius:12, padding:"18px 20px", color:"#fff",
      boxShadow:`0 4px 20px ${color}40`, flex:1, minWidth:140,
    }}>
      <div style={{fontSize:22, marginBottom:4}}>{icon}</div>
      <div style={{fontSize:24, fontWeight:800, letterSpacing:-0.5}}>{value}</div>
      <div style={{fontSize:11, opacity:0.85, fontWeight:600, marginTop:2}}>{label}</div>
      {sub && <div style={{fontSize:10, opacity:0.65, marginTop:3}}>{sub}</div>}
    </div>
  );
}

function Modal({ open, onClose, title, children, width=560 }) {
  if (!open) return null;
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(7,5,26,0.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={onClose}>
      <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:width,maxHeight:"90vh",overflow:"auto",padding:28,position:"relative"}} onClick={e=>e.stopPropagation()}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
          <h3 style={{color:C.navy,fontWeight:800,fontSize:18}}>{title}</h3>
          <button onClick={onClose} style={{background:"#f5f5f5",border:"none",borderRadius:8,width:32,height:32,cursor:"pointer",fontSize:16,color:"#666"}}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type="text", placeholder="", style={}, options }) {
  return (
    <div style={{marginBottom:14}}>
      <label style={{display:"block",fontSize:11,fontWeight:700,color:C.navy,marginBottom:5,textTransform:"uppercase",letterSpacing:0.5}}>{label}</label>
      {options ? (
        <select value={value} onChange={e=>onChange(e.target.value)}
          style={{width:"100%",padding:"10px 12px",borderRadius:8,border:"1.5px solid #DDD",fontSize:13,background:"#FAFAFA",outline:"none",...style}}>
          <option value="">Select...</option>
          {options.map(o=><option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input type={type} value={value} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
          style={{width:"100%",padding:"10px 12px",borderRadius:8,border:"1.5px solid #DDD",fontSize:13,background:"#FAFAFA",outline:"none",boxSizing:"border-box",...style}}/>
      )}
    </div>
  );
}

function Btn({ children, onClick, variant="primary", style={}, small=false }) {
  const styles = {
    primary: { background:`linear-gradient(135deg, ${C.gold} 0%, ${C.gold2} 100%)`, color:C.dark },
    secondary: { background:C.navy, color:"#fff" },
    ghost: { background:"transparent", color:C.navy, border:`1.5px solid ${C.navy}` },
    danger: { background:"#FFEBEE", color:"#C62828", border:"1.5px solid #EF9A9A" },
    success: { background:"#E8F5E9", color:"#2E7D32", border:"1.5px solid #A5D6A7" },
  };
  return (
    <button onClick={onClick} style={{
      padding: small ? "6px 14px" : "10px 20px",
      borderRadius:8, border:"none", cursor:"pointer",
      fontSize: small ? 11 : 13, fontWeight:700,
      ...styles[variant], ...style
    }}>{children}</button>
  );
}

function Table({ columns, data, onRowClick }) {
  return (
    <div style={{overflowX:"auto"}}>
      <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
        <thead>
          <tr style={{background:C.navy}}>
            {columns.map(col=>(
              <th key={col.key} style={{padding:"10px 14px",color:C.gold2,fontWeight:700,textAlign:"left",whiteSpace:"nowrap",fontSize:11,letterSpacing:0.5}}>{col.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr><td colSpan={columns.length} style={{padding:32,textAlign:"center",color:"#999",fontSize:13}}>No records found</td></tr>
          ) : data.map((row, ri)=>(
            <tr key={ri} onClick={()=>onRowClick&&onRowClick(row)}
              style={{background:ri%2===0?"#fff":"#FAFAFA", cursor:onRowClick?"pointer":"default",
                transition:"background 0.15s"}}
              onMouseEnter={e=>{if(onRowClick)e.currentTarget.style.background="#F0EDFF"}}
              onMouseLeave={e=>{e.currentTarget.style.background=ri%2===0?"#fff":"#FAFAFA"}}>
              {columns.map(col=>(
                <td key={col.key} style={{padding:"10px 14px",borderBottom:"1px solid #F0F0F0",whiteSpace:col.wrap?"normal":"nowrap"}}>
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function AIPanel({ open, onClose, context, data }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);
  const bottomRef = useRef();

  useEffect(()=>{
    if(open && messages.length===0) {
      setMessages([{ role:"assistant", content:`👋 Hi Raj! I'm your MyFootSpa AI assistant. I have full access to your business data — bookings, payments, staff, inventory, and P&L.\n\nI can help you with:\n• 📊 Business insights & analysis\n• 💡 Smart suggestions\n• 📝 Draft emails & messages\n• 🔍 Answer questions about your data\n\nWhat do you need?` }]);
    }
  },[open]);

  useEffect(()=>{ bottomRef.current?.scrollIntoView({behavior:"smooth"}); },[messages]);

  async function sendMessage() {
    if(!input.trim() || loading) return;
    const userMsg = input.trim();
    setInput(""); setLoading(true);
    setMessages(m=>[...m,{role:"user",content:userMsg}]);

    const systemPrompt = `You are the AI business assistant for MyFootSpa — India's premium mobile foot and body wellness company based in Hyderabad. You are embedded inside their ERP system.

BUSINESS DATA:
${JSON.stringify(data, null, 2)}

COMPANY INFO:
- Name: MyFootSpa
- Owner: Raj (Sai Raj Vennam)  
- Location: Banjara Hills, Hyderabad
- Phone: +91 98665 77237
- Email: contact@myfootspa.co.in
- Website: www.myfootspa.co.in
- Services: Premium Weddings, Corporate Events, Hotel Programs, VIP Lounges, Sports Events, Exhibitions, Music Festivals, Golf Tournaments, Marathon Events

You have access to all their live business data above. Provide specific, actionable insights. Be concise, warm, and professional. Use Indian Rupee ₹ for all amounts. Format responses clearly with emojis where helpful.`;

    try {
      const res = await fetch("https://api.anthropic.com/v1/messages", {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          model:"claude-sonnet-4-6",
          max_tokens:1000,
          system: systemPrompt,
          messages:[...messages.filter(m=>m.role!=="assistant"||messages.indexOf(m)>0).map(m=>({role:m.role,content:m.content})),{role:"user",content:userMsg}]
        })
      });
      const json = await res.json();
      const reply = json.content?.[0]?.text || "Sorry, I couldn't process that. Please try again.";
      setMessages(m=>[...m,{role:"assistant",content:reply}]);
    } catch {
      setMessages(m=>[...m,{role:"assistant",content:"⚠️ Connection error. Please check your internet and try again."}]);
    }
    setLoading(false);
  }

  if(!open) return null;
  return (
    <div style={{position:"fixed",bottom:80,right:20,width:360,height:500,background:"#fff",borderRadius:16,boxShadow:"0 8px 40px rgba(14,11,46,0.25)",border:`2px solid ${C.gold}`,zIndex:900,display:"flex",flexDirection:"column",overflow:"hidden"}}>
      <div style={{background:`linear-gradient(135deg, ${C.navy} 0%, ${C.purple} 100%)`,padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{color:C.gold2,fontWeight:800,fontSize:14}}>🤖 MyFootSpa AI</div>
          <div style={{color:"rgba(200,191,160,0.7)",fontSize:10}}>Your smart business assistant</div>
        </div>
        <button onClick={onClose} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"#fff",borderRadius:8,width:28,height:28,cursor:"pointer",fontSize:14}}>✕</button>
      </div>
      <div style={{flex:1,overflowY:"auto",padding:16,display:"flex",flexDirection:"column",gap:10}}>
        {messages.map((m,i)=>(
          <div key={i} style={{display:"flex",justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
            <div style={{
              maxWidth:"85%",padding:"10px 14px",borderRadius:m.role==="user"?"12px 12px 2px 12px":"12px 12px 12px 2px",
              background:m.role==="user"?`linear-gradient(135deg,${C.gold},${C.gold2})`:C.gray,
              color:m.role==="user"?C.dark:"#333",fontSize:12,lineHeight:1.5,whiteSpace:"pre-wrap"
            }}>{m.content}</div>
          </div>
        ))}
        {loading && (
          <div style={{display:"flex",gap:4,padding:"10px 14px",background:C.gray,borderRadius:"12px 12px 12px 2px",width:"fit-content"}}>
            {[0,0.2,0.4].map((d,i)=>(
              <div key={i} style={{width:6,height:6,borderRadius:"50%",background:C.gold,animation:`bounce 0.8s ${d}s infinite`}}/>
            ))}
          </div>
        )}
        <div ref={bottomRef}/>
      </div>
      <div style={{padding:"12px 14px",borderTop:"1px solid #EEE",display:"flex",gap:8}}>
        <input value={input} onChange={e=>setInput(e.target.value)}
          onKeyDown={e=>e.key==="Enter"&&sendMessage()}
          placeholder="Ask anything about your business..."
          style={{flex:1,padding:"9px 12px",borderRadius:8,border:`1.5px solid ${C.gold}40`,fontSize:12,outline:"none"}}/>
        <button onClick={sendMessage} disabled={loading}
          style={{background:`linear-gradient(135deg,${C.gold},${C.gold2})`,border:"none",borderRadius:8,width:36,height:36,cursor:"pointer",fontSize:16}}>➤</button>
      </div>
    </div>
  );
}

// ── MAIN ERP APP ─────────────────────────────────────
export default function MyFootSpaERP() {
  const [tab, setTab] = useState("dashboard");
  const [data, setData] = useState(SEED);
  const [aiOpen, setAiOpen] = useState(false);
  const [modal, setModal] = useState(null);
  const [search, setSearch] = useState("");
  const [toast, setToast] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Load from storage
  useEffect(()=>{
    (async()=>{
      const saved = await store.get("mfs_erp_data");
      if(saved) setData(saved);
    })();
  },[]);

  // Save to storage on change
  useEffect(()=>{ store.set("mfs_erp_data",data); },[data]);

  function showToast(msg, type="success") {
    setToast({msg,type});
    setTimeout(()=>setToast(null),3000);
  }

  function addRecord(module, record) {
    setData(d=>({...d,[module]:[...d[module],record]}));
    showToast(`${module.slice(0,-1)} added successfully ✓`);
    setModal(null);
  }

  function deleteRecord(module, id) {
    setData(d=>({...d,[module]:d[module].filter(r=>r.id!==id)}));
    showToast(`Record deleted`,"error");
  }

  // ── COMPUTED METRICS ──
  const totalRevenue = data.payments.filter(p=>p.status==="Paid").reduce((s,p)=>s+p.amount,0);
  const totalPending = data.payments.filter(p=>p.status==="Pending").reduce((s,p)=>s+p.amount,0);
  const totalExpenses = data.expenses.reduce((s,e)=>s+e.amount,0);
  const netProfit = totalRevenue - totalExpenses;
  const activeStaff = data.staff.filter(s=>s.status==="Active").length;
  const totalBookings = data.bookings.length;
  const confirmedBookings = data.bookings.filter(b=>b.status==="Confirmed").length;
  const lowStock = data.inventory.filter(i=>i.qty<=i.minQty).length;

  const NAV = [
    { id:"dashboard", icon:"📊", label:"Dashboard" },
    { id:"bookings",  icon:"📅", label:"Bookings" },
    { id:"payments",  icon:"💰", label:"Payments" },
    { id:"staff",     icon:"👥", label:"Staff & HR" },
    { id:"assignments",icon:"🎯",label:"Assignments" },
    { id:"clients",   icon:"🤝", label:"Clients" },
    { id:"inventory", icon:"📦", label:"Inventory" },
    { id:"pnl",       icon:"📈", label:"P&L Report" },
    { id:"expenses",  icon:"💸", label:"Expenses" },
  ];

  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  // ── FORMS ──
  function BookingForm({ onSave }) {
    const [f, setF] = useState({ id:`BK${String(data.bookings.length+1).padStart(3,"0")}`, client:"", phone:"", eventType:"", date:"", venue:"", city:"Hyderabad", guests:"", therapists:"", hours:"", package:"Essential", amount:"", advance:"0", status:"Enquiry", payStatus:"Unpaid", lead:"", notes:"" });
    const set = (k,v) => setF(p=>({...p,[k]:v}));
    return (
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="Booking ID" value={f.id} onChange={v=>set("id",v)}/>
        <Input label="Client Name" value={f.client} onChange={v=>set("client",v)}/>
        <Input label="Phone" value={f.phone} onChange={v=>set("phone",v)}/>
        <Input label="Event Type" value={f.eventType} onChange={v=>set("eventType",v)} options={["Premium Wedding","Destination Wedding","Corporate Event","Sports Event","Exhibition/Trade Show","Music Festival","Celebrity Event","VIP Lounge","Golf Tournament","Marathon Event","Convention Center","Hotel Program","Employee Wellness","Other"]}/>
        <Input label="Event Date" value={f.date} onChange={v=>set("date",v)} type="date"/>
        <Input label="Venue" value={f.venue} onChange={v=>set("venue",v)}/>
        <Input label="City" value={f.city} onChange={v=>set("city",v)}/>
        <Input label="Guest Count" value={f.guests} onChange={v=>set("guests",v)} type="number"/>
        <Input label="Therapists Needed" value={f.therapists} onChange={v=>set("therapists",v)} type="number"/>
        <Input label="Duration (hours)" value={f.hours} onChange={v=>set("hours",v)} type="number"/>
        <Input label="Package" value={f.package} onChange={v=>set("package",v)} options={["Essential (8K-15K)","Premium (20K-45K)","Signature (50K-1.5L)","Custom","Retainer"]}/>
        <Input label="Quoted Amount (₹)" value={f.amount} onChange={v=>set("amount",v)} type="number"/>
        <Input label="Advance Received (₹)" value={f.advance} onChange={v=>set("advance",v)} type="number"/>
        <Input label="Status" value={f.status} onChange={v=>set("status",v)} options={["Enquiry","Confirmed","In Progress","Completed","Cancelled"]}/>
        <Input label="Payment Status" value={f.payStatus} onChange={v=>set("payStatus",v)} options={["Unpaid","Advance Paid","Fully Paid","Overdue"]}/>
        <Input label="Lead Staff" value={f.lead} onChange={v=>set("lead",v)} options={data.staff.map(s=>s.name)}/>
        <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
        <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
          <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
          <Btn onClick={()=>addRecord("bookings",{...f,amount:+f.amount,advance:+f.advance,guests:+f.guests,therapists:+f.therapists,hours:+f.hours})}>Save Booking</Btn>
        </div>
      </div>
    );
  }

  function PaymentForm({ onSave }) {
    const [f, setF] = useState({ id:`PAY${String(data.payments.length+1).padStart(3,"0")}`, bookingId:"", client:"", date:new Date().toISOString().split("T")[0], amount:"", status:"Paid", mode:"UPI - GPay", txnId:"", invoice:`INV/25-26/${String(data.payments.length+1).padStart(3,"0")}`, receipt:"Yes - WhatsApp" });
    const set=(k,v)=>setF(p=>({...p,[k]:v}));
    return (
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="Payment ID" value={f.id} onChange={v=>set("id",v)}/>
        <Input label="Booking ID" value={f.bookingId} onChange={v=>set("bookingId",v)} options={data.bookings.map(b=>b.id)}/>
        <Input label="Client Name" value={f.client} onChange={v=>set("client",v)}/>
        <Input label="Payment Date" value={f.date} onChange={v=>set("date",v)} type="date"/>
        <Input label="Amount (₹)" value={f.amount} onChange={v=>set("amount",v)} type="number"/>
        <Input label="Status" value={f.status} onChange={v=>set("status",v)} options={["Paid","Pending","Partial","Overdue","Refunded"]}/>
        <Input label="Payment Mode" value={f.mode} onChange={v=>set("mode",v)} options={["Cash","UPI - PhonePe","UPI - GPay","UPI - Paytm","NEFT/RTGS","IMPS","Bank Transfer","Cheque","Credit Card","Razorpay Link"]}/>
        <Input label="Transaction ID / UTR" value={f.txnId} onChange={v=>set("txnId",v)}/>
        <Input label="Invoice Number" value={f.invoice} onChange={v=>set("invoice",v)}/>
        <Input label="Receipt Sent?" value={f.receipt} onChange={v=>set("receipt",v)} options={["Yes - WhatsApp","Yes - Email","No","N/A"]}/>
        <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
          <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
          <Btn onClick={()=>addRecord("payments",{...f,amount:+f.amount})}>Save Payment</Btn>
        </div>
      </div>
    );
  }

  function StaffForm() {
    const [f,setF] = useState({id:`S${String(data.staff.length+1).padStart(3,"0")}`,name:"",phone:"",role:"Therapist",specialization:"Foot Reflexology",certifications:"",joined:new Date().toISOString().split("T")[0],dailyRate:"",monthlySalary:"0",status:"Active",city:"Hyderabad",emergency:"",notes:""});
    const set=(k,v)=>setF(p=>({...p,[k]:v}));
    return (
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="Staff ID" value={f.id} onChange={v=>set("id",v)}/>
        <Input label="Full Name" value={f.name} onChange={v=>set("name",v)}/>
        <Input label="Phone" value={f.phone} onChange={v=>set("phone",v)}/>
        <Input label="Role" value={f.role} onChange={v=>set("role",v)} options={["Team Lead","Senior Therapist","Therapist","Trainee","Sales Executive","Marketing","Operations","Admin"]}/>
        <Input label="Specialization" value={f.specialization} onChange={v=>set("specialization",v)} options={["Foot Reflexology","Full Body Massage","Aromatherapy","Hot Stone","Deep Tissue","Swedish","Multi-skilled"]}/>
        <Input label="Daily Rate (₹)" value={f.dailyRate} onChange={v=>set("dailyRate",v)} type="number"/>
        <Input label="Monthly Salary (₹)" value={f.monthlySalary} onChange={v=>set("monthlySalary",v)} type="number"/>
        <Input label="Date Joined" value={f.joined} onChange={v=>set("joined",v)} type="date"/>
        <Input label="Status" value={f.status} onChange={v=>set("status",v)} options={["Active","On Leave","Part-Time","Freelance","Inactive"]}/>
        <Input label="City" value={f.city} onChange={v=>set("city",v)}/>
        <Input label="Emergency Contact" value={f.emergency} onChange={v=>set("emergency",v)}/>
        <div style={{gridColumn:"1/-1"}}><Input label="Certifications" value={f.certifications} onChange={v=>set("certifications",v)}/></div>
        <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
        <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
          <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
          <Btn onClick={()=>addRecord("staff",{...f,dailyRate:+f.dailyRate,monthlySalary:+f.monthlySalary})}>Save Staff</Btn>
        </div>
      </div>
    );
  }

  function ExpenseForm() {
    const [f,setF] = useState({id:`EXP${String(data.expenses.length+1).padStart(3,"0")}`,date:new Date().toISOString().split("T")[0],category:"Staff",description:"",amount:"",paidTo:"",mode:"Cash",notes:""});
    const set=(k,v)=>setF(p=>({...p,[k]:v}));
    return (
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
        <Input label="Expense ID" value={f.id} onChange={v=>set("id",v)}/>
        <Input label="Date" value={f.date} onChange={v=>set("date",v)} type="date"/>
        <Input label="Category" value={f.category} onChange={v=>set("category",v)} options={["Staff","Products","Marketing","Transport","Equipment","Admin","Rent","Other"]}/>
        <Input label="Amount (₹)" value={f.amount} onChange={v=>set("amount",v)} type="number"/>
        <div style={{gridColumn:"1/-1"}}><Input label="Description" value={f.description} onChange={v=>set("description",v)}/></div>
        <Input label="Paid To" value={f.paidTo} onChange={v=>set("paidTo",v)}/>
        <Input label="Payment Mode" value={f.mode} onChange={v=>set("mode",v)} options={["Cash","UPI","Bank Transfer","Credit Card","Cheque"]}/>
        <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
        <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
          <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
          <Btn onClick={()=>addRecord("expenses",{...f,amount:+f.amount})}>Save Expense</Btn>
        </div>
      </div>
    );
  }

  // ── PAGE RENDERERS ──────────────────────────────────

  function Dashboard() {
    const recentBookings = [...data.bookings].sort((a,b)=>new Date(b.date)-new Date(a.date)).slice(0,5);
    const upcomingEvents = data.bookings.filter(b=>new Date(b.date)>=new Date()&&b.status!=="Cancelled").sort((a,b)=>new Date(a.date)-new Date(b.date)).slice(0,4);
    const lowStockItems = data.inventory.filter(i=>i.qty<=i.minQty);

    return (
      <div>
        <div style={{marginBottom:20}}>
          <h2 style={{color:C.navy,fontWeight:800,fontSize:22}}>Good morning, Raj! 👋</h2>
          <p style={{color:"#666",fontSize:13,marginTop:2}}>Here's your MyFootSpa business overview</p>
        </div>

        {/* KPI Row */}
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:20}}>
          <KPICard label="Revenue Collected" value={`₹${(totalRevenue/1000).toFixed(0)}K`} sub="All time" color="#1A4A2E" icon="💰"/>
          <KPICard label="Pending Payments" value={`₹${(totalPending/1000).toFixed(0)}K`} sub="Needs follow-up" color="#7A5500" icon="⏳"/>
          <KPICard label="Net Profit" value={`₹${(netProfit/1000).toFixed(0)}K`} sub="Revenue - Expenses" color={netProfit>=0?"#0D3D6E":"#7A1A1A"} icon="📈"/>
          <KPICard label="Total Bookings" value={totalBookings} sub={`${confirmedBookings} confirmed`} color="#231960" icon="📅"/>
          <KPICard label="Active Staff" value={activeStaff} sub="Ready to deploy" color="#0E0B2E" icon="👥"/>
          <KPICard label="Low Stock Alerts" value={lowStock} sub="Items need restock" color={lowStock>0?"#7A1A1A":"#1A4A2E"} icon="📦"/>
        </div>

        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:16}}>
          {/* Upcoming Events */}
          <Card>
            <h3 style={{color:C.navy,fontWeight:800,fontSize:14,marginBottom:14}}>🗓️ Upcoming Events</h3>
            {upcomingEvents.length===0 ? <p style={{color:"#999",fontSize:13}}>No upcoming events</p> :
              upcomingEvents.map(e=>(
                <div key={e.id} style={{padding:"10px 0",borderBottom:"1px solid #F0F0F0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:C.navy}}>{e.client}</div>
                    <div style={{fontSize:11,color:"#666"}}>{e.eventType} • {e.venue}</div>
                    <div style={{fontSize:11,color:C.gold,fontWeight:600}}>{e.date}</div>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <Badge status={e.status}/>
                    <div style={{fontSize:11,color:"#666",marginTop:4}}>₹{e.amount?.toLocaleString()}</div>
                  </div>
                </div>
              ))
            }
          </Card>

          {/* Quick Stats */}
          <Card>
            <h3 style={{color:C.navy,fontWeight:800,fontSize:14,marginBottom:14}}>📊 Financial Snapshot</h3>
            {[
              ["Total Revenue","₹"+totalRevenue.toLocaleString(),C.green2],
              ["Total Expenses","₹"+totalExpenses.toLocaleString(),"#C62828"],
              ["Net Profit","₹"+netProfit.toLocaleString(),netProfit>=0?C.green2:"#C62828"],
              ["Pending Collections","₹"+totalPending.toLocaleString(),C.amber],
              ["Profit Margin",totalRevenue>0?((netProfit/totalRevenue)*100).toFixed(1)+"%":"0%",C.blue],
            ].map(([label,value,color])=>(
              <div key={label} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid #F5F5F5"}}>
                <span style={{fontSize:12,color:"#666"}}>{label}</span>
                <span style={{fontSize:13,fontWeight:800,color}}>{value}</span>
              </div>
            ))}
            {lowStock > 0 && (
              <div style={{marginTop:12,background:"#FFEBEE",borderRadius:8,padding:"8px 12px",border:"1px solid #EF9A9A"}}>
                <span style={{fontSize:12,color:"#C62828",fontWeight:700}}>⚠️ {lowStock} item(s) low on stock</span>
              </div>
            )}
          </Card>
        </div>

        {/* Low Stock Alert */}
        {lowStockItems.length > 0 && (
          <Card style={{borderLeft:`4px solid #C62828`,background:"#FFEBEE20"}}>
            <h3 style={{color:"#C62828",fontWeight:800,fontSize:13,marginBottom:10}}>⚠️ Low Stock Alert — Restock Needed</h3>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              {lowStockItems.map(i=>(
                <div key={i.id} style={{background:"#FFEBEE",border:"1px solid #EF9A9A",borderRadius:8,padding:"6px 12px"}}>
                  <span style={{fontSize:11,fontWeight:700,color:"#C62828"}}>{i.item}</span>
                  <span style={{fontSize:10,color:"#E57373",marginLeft:6}}>{i.qty} {i.unit} left (min: {i.minQty})</span>
                </div>
              ))}
            </div>
          </Card>
        )}
      </div>
    );
  }

  function BookingsPage() {
    const filtered = data.bookings.filter(b=>
      b.client?.toLowerCase().includes(search.toLowerCase()) ||
      b.eventType?.toLowerCase().includes(search.toLowerCase()) ||
      b.id?.toLowerCase().includes(search.toLowerCase())
    );
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>📅 Bookings</h2>
            <p style={{color:"#666",fontSize:12}}>{data.bookings.length} total bookings</p>
          </div>
          <Btn onClick={()=>setModal("booking")}>+ New Booking</Btn>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"BK#"},
              {key:"client",label:"Client"},
              {key:"eventType",label:"Event Type"},
              {key:"date",label:"Date"},
              {key:"venue",label:"Venue"},
              {key:"guests",label:"Guests"},
              {key:"amount",label:"Amount",render:v=>`₹${v?.toLocaleString()||0}`},
              {key:"advance",label:"Advance",render:v=>`₹${v?.toLocaleString()||0}`},
              {key:"status",label:"Status",render:v=><Badge status={v}/>},
              {key:"payStatus",label:"Payment",render:v=><Badge status={v}/>},
              {key:"id",label:"",render:(v,row)=><Btn small variant="danger" onClick={()=>deleteRecord("bookings",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
      </div>
    );
  }

  function PaymentsPage() {
    const filtered = data.payments.filter(p=>
      p.client?.toLowerCase().includes(search.toLowerCase()) ||
      p.id?.toLowerCase().includes(search.toLowerCase())
    );
    const collected = data.payments.filter(p=>p.status==="Paid").reduce((s,p)=>s+p.amount,0);
    const pending = data.payments.filter(p=>p.status==="Pending").reduce((s,p)=>s+p.amount,0);
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>💰 Payments</h2>
            <p style={{color:"#666",fontSize:12}}>Online & offline payment tracking</p>
          </div>
          <Btn onClick={()=>setModal("payment")}>+ Log Payment</Btn>
        </div>
        <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
          <KPICard label="Collected" value={`₹${collected.toLocaleString()}`} color={C.green} icon="✅" style={{flex:1}}/>
          <KPICard label="Pending" value={`₹${pending.toLocaleString()}`} color={C.amber} icon="⏳" style={{flex:1}}/>
          <KPICard label="Total Transactions" value={data.payments.length} color={C.blue} icon="🧾" style={{flex:1}}/>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"PAY#"},
              {key:"bookingId",label:"BK#"},
              {key:"client",label:"Client"},
              {key:"date",label:"Date"},
              {key:"amount",label:"Amount",render:v=>`₹${v?.toLocaleString()||0}`},
              {key:"status",label:"Status",render:v=><Badge status={v}/>},
              {key:"mode",label:"Mode"},
              {key:"txnId",label:"Transaction ID"},
              {key:"receipt",label:"Receipt"},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("payments",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
      </div>
    );
  }

  function StaffPage() {
    const filtered = data.staff.filter(s=>
      s.name?.toLowerCase().includes(search.toLowerCase()) ||
      s.role?.toLowerCase().includes(search.toLowerCase())
    );
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>👥 Staff & HR</h2>
            <p style={{color:"#666",fontSize:12}}>{data.staff.length} team members</p>
          </div>
          <Btn onClick={()=>setModal("staff")}>+ Add Staff</Btn>
        </div>
        <div style={{display:"flex",gap:12,marginBottom:16,flexWrap:"wrap"}}>
          {["Active","On Leave","Inactive"].map(s=>(
            <KPICard key={s} label={s} value={data.staff.filter(st=>st.status===s).length}
              color={s==="Active"?C.green:s==="On Leave"?C.amber:C.red} icon={s==="Active"?"✅":s==="On Leave"?"🏖️":"❌"}/>
          ))}
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"ID"},
              {key:"name",label:"Name"},
              {key:"phone",label:"Phone"},
              {key:"role",label:"Role"},
              {key:"specialization",label:"Skill"},
              {key:"dailyRate",label:"Day Rate",render:v=>v?`₹${v?.toLocaleString()}`:"Monthly"},
              {key:"monthlySalary",label:"Monthly",render:v=>v?`₹${v?.toLocaleString()}`:"Per Day"},
              {key:"status",label:"Status",render:v=><Badge status={v}/>},
              {key:"city",label:"City"},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("staff",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
      </div>
    );
  }

  function AssignmentsPage() {
    const filtered = data.assignments.filter(a=>
      a.staff?.toLowerCase().includes(search.toLowerCase()) ||
      a.client?.toLowerCase().includes(search.toLowerCase())
    );
    function AssignForm() {
      const [f,setF]=useState({id:`AS${String(data.assignments.length+1).padStart(3,"0")}`,bookingId:"",staff:"",date:"",eventType:"",client:"",venue:"",shiftStart:"09:00",shiftEnd:"18:00",role:"Therapist",attendance:"Assigned",dayRate:"",notes:""});
      const set=(k,v)=>setF(p=>({...p,[k]:v}));
      return (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
          <Input label="Assignment ID" value={f.id} onChange={v=>set("id",v)}/>
          <Input label="Booking ID" value={f.bookingId} onChange={v=>set("bookingId",v)} options={data.bookings.map(b=>b.id)}/>
          <Input label="Staff Member" value={f.staff} onChange={v=>set("staff",v)} options={data.staff.map(s=>s.name)}/>
          <Input label="Event Date" value={f.date} onChange={v=>set("date",v)} type="date"/>
          <Input label="Client" value={f.client} onChange={v=>set("client",v)}/>
          <Input label="Venue" value={f.venue} onChange={v=>set("venue",v)}/>
          <Input label="Shift Start" value={f.shiftStart} onChange={v=>set("shiftStart",v)} type="time"/>
          <Input label="Shift End" value={f.shiftEnd} onChange={v=>set("shiftEnd",v)} type="time"/>
          <Input label="Role for Event" value={f.role} onChange={v=>set("role",v)} options={["Lead Therapist","Therapist","Trainee","Setup Crew","Supervisor","Operations"]}/>
          <Input label="Day Rate (₹)" value={f.dayRate} onChange={v=>set("dayRate",v)} type="number"/>
          <Input label="Attendance" value={f.attendance} onChange={v=>set("attendance",v)} options={["Assigned","Confirmed","Present","Absent","Late","Replaced"]}/>
          <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
          <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
            <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
            <Btn onClick={()=>addRecord("assignments",{...f,dayRate:+f.dayRate})}>Save Assignment</Btn>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>🎯 Staff Assignments</h2>
            <p style={{color:"#666",fontSize:12}}>Who goes to which event</p>
          </div>
          <Btn onClick={()=>setModal("assignment")}>+ Assign Staff</Btn>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"AS#"},
              {key:"bookingId",label:"BK#"},
              {key:"staff",label:"Staff"},
              {key:"date",label:"Date"},
              {key:"client",label:"Client"},
              {key:"venue",label:"Venue"},
              {key:"shiftStart",label:"Start"},
              {key:"shiftEnd",label:"End"},
              {key:"role",label:"Role"},
              {key:"dayRate",label:"Rate",render:v=>`₹${v?.toLocaleString()||0}`},
              {key:"attendance",label:"Status",render:v=><Badge status={v}/>},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("assignments",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
        <Modal open={modal==="assignment"} onClose={()=>setModal(null)} title="Assign Staff to Event" width={600}>
          <AssignForm/>
        </Modal>
      </div>
    );
  }

  function ClientsPage() {
    const filtered = data.clients.filter(c=>
      c.company?.toLowerCase().includes(search.toLowerCase()) ||
      c.type?.toLowerCase().includes(search.toLowerCase())
    );
    function ClientForm() {
      const [f,setF]=useState({id:`CL${String(data.clients.length+1).padStart(3,"0")}`,company:"",contact:"",phone:"",email:"",type:"Corporate/IT",city:"Hyderabad",status:"Active",notes:""});
      const set=(k,v)=>setF(p=>({...p,[k]:v}));
      return (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
          <Input label="Client ID" value={f.id} onChange={v=>set("id",v)}/>
          <Input label="Company / Name" value={f.company} onChange={v=>set("company",v)}/>
          <Input label="Contact Person" value={f.contact} onChange={v=>set("contact",v)}/>
          <Input label="Phone" value={f.phone} onChange={v=>set("phone",v)}/>
          <Input label="Email" value={f.email} onChange={v=>set("email",v)}/>
          <Input label="Client Type" value={f.type} onChange={v=>set("type",v)} options={["Corporate/IT","5-Star Hotel","Wedding Client","Event Planner","Individual/VIP","Sports Org","Other"]}/>
          <Input label="City" value={f.city} onChange={v=>set("city",v)}/>
          <Input label="Status" value={f.status} onChange={v=>set("status",v)} options={["Active","Retainer","One-Time","Inactive","VIP","Prospect"]}/>
          <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
          <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
            <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
            <Btn onClick={()=>addRecord("clients",f)}>Save Client</Btn>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>🤝 Clients</h2>
            <p style={{color:"#666",fontSize:12}}>{data.clients.length} clients in database</p>
          </div>
          <Btn onClick={()=>setModal("client")}>+ Add Client</Btn>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"CL#"},
              {key:"company",label:"Company"},
              {key:"contact",label:"Contact"},
              {key:"phone",label:"Phone"},
              {key:"type",label:"Type"},
              {key:"city",label:"City"},
              {key:"status",label:"Status",render:v=><Badge status={v}/>},
              {key:"notes",label:"Notes",wrap:true},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("clients",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
        <Modal open={modal==="client"} onClose={()=>setModal(null)} title="Add New Client" width={560}>
          <ClientForm/>
        </Modal>
      </div>
    );
  }

  function InventoryPage() {
    const filtered = data.inventory.filter(i=>i.item?.toLowerCase().includes(search.toLowerCase())||i.category?.toLowerCase().includes(search.toLowerCase()));
    function InvForm() {
      const [f,setF]=useState({id:`INV${String(data.inventory.length+1).padStart(3,"0")}`,item:"",category:"Products",qty:"",unit:"Pcs",minQty:"",cost:"",supplier:"",lastRestocked:new Date().toISOString().split("T")[0],notes:""});
      const set=(k,v)=>setF(p=>({...p,[k]:v}));
      return (
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"0 16px"}}>
          <Input label="Item ID" value={f.id} onChange={v=>set("id",v)}/>
          <Input label="Item Name" value={f.item} onChange={v=>set("item",v)}/>
          <Input label="Category" value={f.category} onChange={v=>set("category",v)} options={["Equipment","Products","Consumables","Linen","Marketing","Other"]}/>
          <Input label="Unit" value={f.unit} onChange={v=>set("unit",v)} options={["Pcs","Kg","Bottles","Sets","Litres","Boxes"]}/>
          <Input label="Current Qty" value={f.qty} onChange={v=>set("qty",v)} type="number"/>
          <Input label="Min Qty (Alert)" value={f.minQty} onChange={v=>set("minQty",v)} type="number"/>
          <Input label="Unit Cost (₹)" value={f.cost} onChange={v=>set("cost",v)} type="number"/>
          <Input label="Supplier" value={f.supplier} onChange={v=>set("supplier",v)}/>
          <Input label="Last Restocked" value={f.lastRestocked} onChange={v=>set("lastRestocked",v)} type="date"/>
          <div style={{gridColumn:"1/-1"}}><Input label="Notes" value={f.notes} onChange={v=>set("notes",v)}/></div>
          <div style={{gridColumn:"1/-1",display:"flex",gap:10,justifyContent:"flex-end",marginTop:8}}>
            <Btn onClick={()=>setModal(null)} variant="ghost">Cancel</Btn>
            <Btn onClick={()=>addRecord("inventory",{...f,qty:+f.qty,minQty:+f.minQty,cost:+f.cost})}>Save Item</Btn>
          </div>
        </div>
      );
    }
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>📦 Inventory</h2>
            <p style={{color:"#666",fontSize:12}}>{lowStock > 0 ? `⚠️ ${lowStock} items need restocking` : "All stock levels OK"}</p>
          </div>
          <Btn onClick={()=>setModal("inventory")}>+ Add Item</Btn>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"ID"},
              {key:"item",label:"Item"},
              {key:"category",label:"Category"},
              {key:"qty",label:"Qty",render:(v,row)=>(
                <span style={{color:v<=row.minQty?"#C62828":C.green2,fontWeight:700}}>{v} {row.unit}</span>
              )},
              {key:"minQty",label:"Min Qty"},
              {key:"cost",label:"Unit Cost",render:v=>`₹${v?.toLocaleString()||0}`},
              {key:"supplier",label:"Supplier"},
              {key:"lastRestocked",label:"Last Restocked"},
              {key:"qty",label:"Status",render:(v,row)=><Badge status={v<=row.minQty?"Overdue":"Active"}/>},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("inventory",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
        <Modal open={modal==="inventory"} onClose={()=>setModal(null)} title="Add Inventory Item" width={560}>
          <InvForm/>
        </Modal>
      </div>
    );
  }

  function PnLPage() {
    const byCategory = data.expenses.reduce((acc,e)=>{
      acc[e.category]=(acc[e.category]||0)+e.amount; return acc;
    },{});
    const margin = totalRevenue > 0 ? ((netProfit/totalRevenue)*100).toFixed(1) : 0;
    return (
      <div>
        <h2 style={{color:C.navy,fontWeight:800,fontSize:20,marginBottom:16}}>📈 P&L Report</h2>
        <div style={{display:"flex",gap:12,flexWrap:"wrap",marginBottom:20}}>
          <KPICard label="Total Revenue" value={`₹${totalRevenue.toLocaleString()}`} color={C.green} icon="💰"/>
          <KPICard label="Total Expenses" value={`₹${totalExpenses.toLocaleString()}`} color={C.red} icon="💸"/>
          <KPICard label="Net Profit" value={`₹${netProfit.toLocaleString()}`} color={netProfit>=0?C.blue:C.red} icon="📊"/>
          <KPICard label="Profit Margin" value={`${margin}%`} color={C.purple} icon="📉"/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
          <Card>
            <h3 style={{color:C.navy,fontWeight:800,fontSize:14,marginBottom:14}}>💰 Revenue Breakdown</h3>
            {[
              ["Collected","₹"+totalRevenue.toLocaleString(),C.green2],
              ["Pending","₹"+totalPending.toLocaleString(),C.amber],
              ["Total Invoiced","₹"+(totalRevenue+totalPending).toLocaleString(),C.blue],
            ].map(([l,v,c])=>(
              <div key={l} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:"1px solid #F5F5F5"}}>
                <span style={{fontSize:13,color:"#666"}}>{l}</span>
                <span style={{fontSize:14,fontWeight:800,color:c}}>{v}</span>
              </div>
            ))}
          </Card>
          <Card>
            <h3 style={{color:C.navy,fontWeight:800,fontSize:14,marginBottom:14}}>💸 Expenses by Category</h3>
            {Object.entries(byCategory).map(([cat,amt])=>(
              <div key={cat} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid #F5F5F5"}}>
                <span style={{fontSize:12,color:"#666"}}>{cat}</span>
                <div style={{display:"flex",alignItems:"center",gap:10}}>
                  <div style={{width:80,height:6,background:"#F0F0F0",borderRadius:3,overflow:"hidden"}}>
                    <div style={{width:`${(amt/totalExpenses*100)}%`,height:"100%",background:C.gold,borderRadius:3}}/>
                  </div>
                  <span style={{fontSize:12,fontWeight:700,color:C.red,minWidth:70,textAlign:"right"}}>₹{amt.toLocaleString()}</span>
                </div>
              </div>
            ))}
            <div style={{display:"flex",justifyContent:"space-between",padding:"10px 0",marginTop:4}}>
              <span style={{fontSize:13,fontWeight:800,color:C.navy}}>Total Expenses</span>
              <span style={{fontSize:14,fontWeight:800,color:"#C62828"}}>₹{totalExpenses.toLocaleString()}</span>
            </div>
          </Card>
        </div>
      </div>
    );
  }

  function ExpensesPage() {
    const filtered = data.expenses.filter(e=>e.description?.toLowerCase().includes(search.toLowerCase())||e.category?.toLowerCase().includes(search.toLowerCase()));
    return (
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div>
            <h2 style={{color:C.navy,fontWeight:800,fontSize:20}}>💸 Expenses</h2>
            <p style={{color:"#666",fontSize:12}}>Total: ₹{totalExpenses.toLocaleString()}</p>
          </div>
          <Btn onClick={()=>setModal("expense")}>+ Log Expense</Btn>
        </div>
        <Card>
          <Table
            columns={[
              {key:"id",label:"ID"},
              {key:"date",label:"Date"},
              {key:"category",label:"Category"},
              {key:"description",label:"Description",wrap:true},
              {key:"amount",label:"Amount",render:v=><span style={{fontWeight:700,color:"#C62828"}}>₹{v?.toLocaleString()||0}</span>},
              {key:"paidTo",label:"Paid To"},
              {key:"mode",label:"Mode"},
              {key:"id",label:"",render:(v)=><Btn small variant="danger" onClick={()=>deleteRecord("expenses",v)}>✕</Btn>},
            ]}
            data={filtered}
          />
        </Card>
      </div>
    );
  }

  const pages = { dashboard:<Dashboard/>, bookings:<BookingsPage/>, payments:<PaymentsPage/>, staff:<StaffPage/>, assignments:<AssignmentsPage/>, clients:<ClientsPage/>, inventory:<InventoryPage/>, pnl:<PnLPage/>, expenses:<ExpensesPage/> };

  return (
    <div style={{display:"flex",minHeight:"100vh",background:"#F5F5F5",fontFamily:"'Inter',system-ui,sans-serif"}}>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; }
        ::-webkit-scrollbar { width: 6px; height: 6px; }
        ::-webkit-scrollbar-track { background: #f1f1f1; }
        ::-webkit-scrollbar-thumb { background: #C9A030; border-radius: 3px; }
        @keyframes bounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-6px)} }
      `}</style>

      {/* SIDEBAR */}
      <div style={{
        width:220, background:`linear-gradient(180deg, ${C.dark} 0%, ${C.navy} 100%)`,
        display:"flex", flexDirection:"column", flexShrink:0,
        position:"fixed", top:0, left: sidebarOpen||true ? 0 : -220,
        height:"100vh", zIndex:200, transition:"left 0.3s",
        overflowY:"auto",
      }}>
        {/* Brand */}
        <div style={{padding:"20px 16px 16px",borderBottom:"1px solid rgba(201,160,48,0.2)"}}>
          <div style={{color:C.gold2,fontWeight:800,fontSize:16,letterSpacing:0.5}}>🌸 MyFootSpa</div>
          <div style={{color:"rgba(200,191,160,0.6)",fontSize:10,marginTop:2,letterSpacing:1}}>ERP SYSTEM</div>
        </div>
        {/* Nav */}
        <nav style={{flex:1,padding:"12px 8px"}}>
          {NAV.map(n=>(
            <button key={n.id} onClick={()=>setTab(n.id)}
              style={{
                display:"flex", alignItems:"center", gap:10,
                width:"100%", padding:"10px 12px", borderRadius:10, border:"none",
                cursor:"pointer", marginBottom:2, textAlign:"left",
                background: tab===n.id ? `linear-gradient(135deg,${C.gold}22,${C.gold}11)` : "transparent",
                borderLeft: tab===n.id ? `3px solid ${C.gold}` : "3px solid transparent",
                color: tab===n.id ? C.gold2 : "rgba(200,191,160,0.7)",
                fontWeight: tab===n.id ? 700 : 400,
                fontSize: 13, transition:"all 0.2s",
              }}>
              <span style={{fontSize:15}}>{n.icon}</span>
              {n.label}
            </button>
          ))}
        </nav>
        {/* Bottom info */}
        <div style={{padding:"12px 16px",borderTop:"1px solid rgba(201,160,48,0.15)"}}>
          <div style={{color:"rgba(200,191,160,0.5)",fontSize:9,letterSpacing:0.5}}>+91 98665 77237</div>
          <div style={{color:"rgba(200,191,160,0.4)",fontSize:9}}>myfootspa.co.in</div>
        </div>
      </div>

      {/* MAIN */}
      <div style={{flex:1,marginLeft:220,display:"flex",flexDirection:"column",minHeight:"100vh"}}>
        {/* Top bar */}
        <div style={{background:"#fff",padding:"12px 24px",display:"flex",alignItems:"center",justifyContent:"space-between",borderBottom:"1px solid #EEE",position:"sticky",top:0,zIndex:100,boxShadow:"0 2px 8px rgba(0,0,0,0.04)"}}>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            <div style={{background:`linear-gradient(135deg,${C.navy},${C.purple})`,borderRadius:8,padding:"6px 12px",color:C.gold2,fontWeight:700,fontSize:11,letterSpacing:1}}>
              {NAV.find(n=>n.id===tab)?.icon} {NAV.find(n=>n.id===tab)?.label?.toUpperCase()}
            </div>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <input value={search} onChange={e=>setSearch(e.target.value)}
              placeholder="🔍 Search..."
              style={{padding:"7px 14px",borderRadius:20,border:"1.5px solid #EEE",fontSize:12,outline:"none",width:200,background:"#FAFAFA"}}/>
            <button onClick={()=>setAiOpen(o=>!o)}
              style={{background:`linear-gradient(135deg,${C.navy},${C.purple})`,color:C.gold2,border:"none",borderRadius:10,padding:"8px 16px",cursor:"pointer",fontWeight:700,fontSize:12,display:"flex",alignItems:"center",gap:6}}>
              🤖 AI Assistant
            </button>
          </div>
        </div>

        {/* Content */}
        <div style={{flex:1,padding:"24px",overflowY:"auto"}}>
          {pages[tab] || <Dashboard/>}
        </div>
      </div>

      {/* MODALS */}
      <Modal open={modal==="booking"} onClose={()=>setModal(null)} title="New Booking" width={640}>
        <BookingForm/>
      </Modal>
      <Modal open={modal==="payment"} onClose={()=>setModal(null)} title="Log Payment" width={560}>
        <PaymentForm/>
      </Modal>
      <Modal open={modal==="staff"} onClose={()=>setModal(null)} title="Add Staff Member" width={580}>
        <StaffForm/>
      </Modal>
      <Modal open={modal==="expense"} onClose={()=>setModal(null)} title="Log Expense" width={520}>
        <ExpenseForm/>
      </Modal>

      {/* AI PANEL */}
      <AIPanel open={aiOpen} onClose={()=>setAiOpen(false)} data={data}/>

      {/* AI FAB */}
      <button onClick={()=>setAiOpen(o=>!o)}
        style={{position:"fixed",bottom:20,right:20,width:56,height:56,borderRadius:"50%",background:`linear-gradient(135deg,${C.navy},${C.purple})`,border:`2px solid ${C.gold}`,color:C.gold2,fontSize:22,cursor:"pointer",boxShadow:"0 4px 20px rgba(14,11,46,0.4)",zIndex:800,display:"flex",alignItems:"center",justifyContent:"center"}}>
        🤖
      </button>

      {/* TOAST */}
      {toast && (
        <div style={{position:"fixed",bottom:90,left:"50%",transform:"translateX(-50%)",background:toast.type==="error"?"#FFEBEE":"#E8F5E9",border:`1.5px solid ${toast.type==="error"?"#EF9A9A":"#A5D6A7"}`,color:toast.type==="error"?"#C62828":"#2E7D32",padding:"10px 20px",borderRadius:10,fontWeight:700,fontSize:13,boxShadow:"0 4px 20px rgba(0,0,0,0.15)",zIndex:2000,whiteSpace:"nowrap"}}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
